import { render } from "./adminHome.vue?vue&type=template&id=23da256a&ts=true"
import script from "./adminHome.vue?vue&type=script&lang=ts"
export * from "./adminHome.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__